/** Chip Option 2 as CSS/SVG type. Do not crop or fight the tall-final-E PNG. PWA icons stay out. */

const NAVY = '#0A1628';
const COBALT = '#2F6BFF';
const SERIF = 'Georgia, "Times New Roman", "Liberation Serif", serif';
const SANS = 'Manrope, system-ui, sans-serif';

/** Only the initial C is cap-height. ONCOURS + final E share one reduced size. */
const SMALL_RATIO = 0.7;

/** Optical ink height — gate ~44px / header ~32px, not the 720px PNG frame. */
const SCALE = {
  hero: { optical: 44, cap: 24, travel: 7, plane: 8, rulePad: 3, travelPad: 2 },
  header: { optical: 32, cap: 17.5, travel: 5, plane: 6, rulePad: 2, travelPad: 1.5 },
} as const;

function RulePlane({ size }: { size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      aria-hidden="true"
      className="shrink-0"
    >
      <path
        fill={COBALT}
        d="M8 1.15c.22 0 .4.1.46.3l.9 3.55 5.29 1.85v1.12L8.46 7.2v3.62l1.95 1.22v.98L8 12.15l-2.41.87v-.98l1.95-1.22V7.2L1.35 7.97V6.85l5.29-1.85.9-3.55A.5.5 0 0 1 8 1.15Z"
      />
    </svg>
  );
}

export function BrandLockup({
  variant,
}: {
  variant: 'hero' | 'header';
}) {
  const hero = variant === 'hero';
  const s = SCALE[variant];
  const small = s.cap * SMALL_RATIO;

  return (
    <div className={`flex min-w-0 ${hero ? 'justify-center' : 'justify-start'}`}>
      <div
        className="inline-flex flex-col items-stretch justify-center overflow-visible"
        style={{ height: s.optical }}
        aria-label="Concourse Travel"
      >
        <div
          className="flex items-baseline whitespace-nowrap leading-none"
          style={{ fontFamily: SERIF, color: NAVY, fontWeight: 400 }}
        >
          <span style={{ fontSize: s.cap, letterSpacing: '0.02em' }}>C</span>
          <span
            style={{
              fontSize: small,
              letterSpacing: '0.055em',
              marginLeft: '0.02em',
            }}
          >
            ONCOURSE
          </span>
        </div>
        <div
          className="flex w-full items-center"
          style={{ marginTop: s.rulePad }}
          aria-hidden="true"
        >
          <span className="h-px min-w-0 flex-[0.85]" style={{ background: COBALT }} />
          <RulePlane size={s.plane} />
          <span className="h-px min-w-0 flex-[3.15]" style={{ background: COBALT }} />
        </div>
        <div
          className="flex justify-between leading-none"
          style={{
            fontFamily: SANS,
            color: COBALT,
            fontSize: s.travel,
            fontWeight: 500,
            marginTop: s.travelPad,
            paddingLeft: '7%',
            paddingRight: '7%',
          }}
        >
          {['T', 'R', 'A', 'V', 'E', 'L'].map((letter) => (
            <span key={letter}>{letter}</span>
          ))}
        </div>
      </div>
    </div>
  );
}
